import Vue from 'vue';
import Router from 'vue-router';

import constants from '../_consts';
import routerConstants from './constants'
import Oauth2LoginSuccess from '../components/authorization/login/Oauth2LoginSuccess.vue';

/**
 * Import container
 */
// Users
import Full from '../containers/Full.vue';
import EventContainer from '../containers/Event.vue';
// Managers
import ManagerDashboard from '../containers/manager/Dashboard.vue';
import DashboardManager from '../views/manager/DashboardManager.vue';
import EventsManager from '../views/manager/EventsManager.vue';
import CalendarManager from '../views/manager/Calendar.vue';
import PlanAndApprove from '../views/manager/PlanAndApprove.vue';
import ManageApproved from '../views/manager/ManageApproved.vue';
import ManageEventDetail from '../views/event/ManageEventDetail.vue';
import SchedulerConfiguration from '../views/schedulerConfig/SchedulerConfiguration.vue';
import ManagerDashboardView from '../views/managerDashboard/ManagerDashboard.vue';
import ManageEmail from '../views/email/ManageEmail.vue';
import EmailHistoriesManagement from '../views/email/EmailHistoriesManagement.vue';
import ManageRelatedEvents from '../views/event/ManageRelatedEvents.vue'
import EmailHistoryDetails from '../views/email/EmailHistoryDetails.vue'

/**
 * Import Reset Password
 */
import ResetPassword from '../components/authorization/ResetPassword.vue';
import UpdatePassword from '../components/authorization/UpdatePassword.vue';

/**
 * Import Views
 */
// Users
import Dashboard from '../views/dashboard/Dashboard.vue';
import Drafts from '../views/Drafts.vue';
import Archived from '../views/Archived.vue';
import Approved from '../views/Approved.vue';
import Review from '../views/Review.vue';
import Submitted from '../views/Submitted.vue';
import Deleted from '../views/Deleted.vue';
import EnterAuthorizationCode from '../components/authorization/mfa/EnterAuthorizationCode.vue';
// import Login from '../components/authorization/login/Login.vue';
import ImportUser from '../components/authorization/ImportUser.vue';

// Client View
import DashboardClientView from '../views/manager/clientView/Dashboard.vue';
import Manage from '../views/manager/clientView/Manage.vue';
import Plan from '../views/manager/clientView/Plan.vue';
import Reports from '../views/manager/clientView/Reports.vue';
import UserManagement from '../views/manager/userManagement/UserManagement.vue';
import GlobalSettings from '../views/manager/globalSettings/GlobalSettings.vue';
import StaffingSection from '../views/manager/staffing/StaffingSection.vue';
import EventStaffingDetail from '../views/staffing/EventStaffingDetail.vue';
import UpcomingReport from '../components/eventManagement/reports/UpcommingReport.vue';
import CompletedReport from '../components/eventManagement/reports/CompletedReport.vue';

import Auth from '@aws-amplify/auth';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  routes: [
    {
      path: '/',
      meta: {requiresAuth: true},
      redirect: '/login'
    },
    {
      path: '/login',
      // component: Login,
      beforeEnter: function () {
        Auth.federatedSignIn();
      },
      meta: { requiresAuth: false }
    },
    {
      path: routerConstants.oauth2LoginSuccess,
      name: 'Oauth2LoginSuccess',
      meta: { requiresAuth: false },
      component: Oauth2LoginSuccess
    },
    {
      path: '/login/mfa',
      component: EnterAuthorizationCode
    },
    {
      path: '/reset-password',
      component: ResetPassword,
      meta: {requiresAuth: false}
    },
    {
      path: '/import',
      component: ImportUser,
      meta: {
        requiresAuth: true,
        deniedRoles: [constants.USER_ROLE.client, constants.USER_ROLE.unknown, constants.USER_ROLE.accountManager]
      }
    },
    {
      path: '/update-password/:token',
      component: UpdatePassword,
      meta: {requiresAuth: false}
    },
    {
      path: routerConstants.clientDashboard.path,
      name: routerConstants.clientDashboard.name,
      component: ManagerDashboardView,
      redirect: routerConstants.clientDashboard.children.dashboard.path,
      children: [
        {
          path: routerConstants.clientDashboard.children.dashboard.path,
          name: routerConstants.clientDashboard.children.dashboard.name,
          component: DashboardClientView
        },
        {
          path: routerConstants.clientDashboard.children.manage.path,
          name: routerConstants.clientDashboard.children.manage.name,
          component: Manage
        },
        {
          path: routerConstants.clientDashboard.children.plan.path,
          name: routerConstants.clientDashboard.children.plan.name,
          component: Plan
        },
        {
          path: routerConstants.clientDashboard.children.reports.path,
          name: routerConstants.clientDashboard.children.reports.name,
          component: Reports,
          redirect: routerConstants.clientDashboard.children.reports.children.upcoming.path,
          children: [
            {
              path: routerConstants.clientDashboard.children.reports.children.completed.path,
              name: routerConstants.clientDashboard.children.reports.children.completed.name,
              component: CompletedReport
            },
            {
              path: routerConstants.clientDashboard.children.reports.children.upcoming.path,
              name: routerConstants.clientDashboard.children.reports.children.upcoming.name,
              component: UpcomingReport
            }
          ]
        }
      ]
    },
    {
      path: '/user',
      name: 'user',
      meta: {requiresAuth: false},
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'userDashboard',
          component: Dashboard
        },
        {
          path: 'events',
          name: 'userEvent',
          redirect: 'drafts',
          component: Drafts
        },
        {
          path: 'drafts',
          name: 'userDrafts',
          component: Drafts
        },
        {
          path: 'submitted',
          name: 'userSubmitted',
          component: Submitted
        },
        {
          path: 'review',
          name: 'userReview',
          component: Review
        },
        {
          path: 'approved',
          name: 'userApproved',
          component: Approved
        },
        {
          path: 'archived',
          name: 'userArchived',
          component: Archived
        },
        {
          path: 'deleted',
          name: 'userDeleted',
          component: Deleted
        },
        {
          path: 'drafts/:eventId',
          name: 'userDraftsEventId',
          component: Drafts
        },
        {
          path: 'submitted/:eventId',
          name: 'userSubmittedEventId',
          component: Submitted
        },
        {
          path: 'review/:eventId',
          name: 'userReviewEventId',
          component: Review
        },
        {
          path: 'approved/:eventId',
          name: 'userApprovedEventId',
          component: Approved
        },
        {
          path: 'archived/:eventId',
          name: 'userArchivedEventId',
          component: Archived
        }
      ]
    },
    {
      path: '/manager',
      name: 'manager',
      redirect: 'manager/dashboard',
      meta: {
        requiresAuth: false,
        deniedRoles: [constants.USER_ROLE.client, constants.USER_ROLE.unknown]
      },
      component: ManagerDashboard,
      children: [
        {
          path: 'dashboard',
          name: 'ManagerDashboard',
          component: DashboardManager
        },
        {
          path: 'calendar',
          name: 'ManagerCalendar',
          component: CalendarManager
        },
        {
          path: 'events',
          name: 'ManagerEvent',
          component: EventsManager
        },
        {
          path: 'plan-and-approve',
          name: 'PlanAndApprove',
          component: PlanAndApprove
        },
        {
          path: 'manage',
          name: constants.viewNames.manageApprovedDashboard,
          component: ManageApproved
        },
        {
          path: 'staffing',
          name: constants.viewNames.staffing,
          component: StaffingSection
        },
        {
          path: 'setting',
          name: 'globalSettings',
          component: GlobalSettings
        },
        {
          path: 'users',
          name: 'managerUsers',
          component: UserManagement
        }
      ]
    },
    {
      path: '/event/:eventId',
      name: 'EventContainer',
      meta: {requiresAuth: false},
      component: EventContainer,
      redirect: 'event/:eventId/details',
      children: [
        {
          path: 'details',
          name: 'ManageEventDetail',
          component: ManageEventDetail
        },
        {
          path: 'email-histories',
          name: 'EmailHistoriesManagement',
          component: EmailHistoriesManagement
        },
        {
          path: 'email',
          name: 'ManageEmail',
          component: ManageEmail
        },
        {
          path: 'email-history-details/:id',
          name: 'EmailHistoryDetailsManagement',
          component: EmailHistoryDetails
        },
        {
          path: 'staffing',
          name: 'EventStaffingDetail',
          component: EventStaffingDetail
        },
        {
          path: 'related-events',
          name: 'ManageRelatedEvent',
          component: ManageRelatedEvents
        }
      ]
    },
    {
      path: '/scheduler-config/:clientId',
      name: 'SchedulerConfiguration',
      component: SchedulerConfiguration
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    Auth.currentAuthenticatedUser().then(() => {
      if (to.matched.some(record => (record.meta.deniedRoles && record.meta.deniedRoles.indexOf(localStorage.getItem(constants.LOCAL_STORE.role)) >= 0))) {
        next();
      } else {
        next({path: '/login', query: {redirect: to.fullPath}});
      }
    }).catch(() => {
      next({path: '/login', query: {redirect: to.fullPath}});
    });
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js